import {
  withTranslation,
} from 'react-i18next';

import NotFoundPageView from './NotFoundPageView';

const TranslatedComponent = withTranslation()(NotFoundPageView);

const Component = TranslatedComponent;

export default Component;
